/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Answer } from './answer';
import { User } from './user';
import { DeckPitchSimple } from './deck-pitch-simple';

export interface DeckQuestion {
  readonly id: string;
  readonly pitch: DeckPitchSimple;
  readonly user: User;
  readonly text: string;
  readonly muted: boolean;
  readonly answer: Answer;
}
